import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    let createAccountModalElement = document.querySelector('.js-CreateAccountModal__section')

    if (createAccountModalElement) {
      createAccountModalElement.classList.remove('CreateAccountModal__reveal')
    }
  }
}


